import Model from '@/core/classes/Model'
import papaparse from 'papaparse'
import moment from 'moment'

export default class CsvFile extends Model {
  /**
   * This to disable checking for primary key
   *
   * @returns {String|Undefined}
   */
  $primaryKey () {
    return undefined
  }

  /**
   * Generate CSV File
   *
   * @returns {Blob}
   */
  generateFile () {
    const rows = this.get('rows')

    const columns = this.get('removeUnusedHeaders', true) && rows.length !== 0
      ? Object.keys(rows[0])
      : this.get('headers')

    const file = papaparse.unparse(rows, { columns })

    // Create blob contain the csv file
    return new Blob([file], { type: 'text/csv;charset=utf-8;' })
  }

  /**
   * Download CSV file
   *
   * @returns {Promise<Object|Error>}
   */
  download () {
    return new Promise((resolve, reject) => {
      try {
        const file = this.generateFile()
        const filename = this.generateFilename()

        // IE 10+ support
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(file, filename)
        } else {
          var url = URL.createObjectURL(file)

          var link = document.createElement('a')
          link.setAttribute('href', url)
          link.setAttribute('data-test', 'downloadedCsvFile')
          link.setAttribute('download', filename)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)

          if (window.Cypress) {
            return
          }

          link.click()
          document.body.removeChild(link)
        }

        resolve({ status: 200 })
      } catch (error) {
        reject(error)
      }
    })
  }

  /**
   * Generate filename
   *
   * @return {String}
   */
  generateFilename () {
    let filename = this.get('filename', 'imbellus')

    // Append timestamp [default: true]
    if (this.get('appendTimestamp', true)) {
      const date = moment.utc().format('YYYYMMDDHHmm')
      filename += `-${date}`
    }

    filename += '.csv'
    return filename
  }
}
